module.exports = __webpack_public_path__ + "img/preloader.5ffb6260.svg";